import React from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";

import generiqueNoir from "../../assets/images/sousmenu/icon_generique_noir.png";
import generiqueBlanc from "../../assets/images/sousmenu/icon_generique_blanc.png";
import onenoteNoir from "../../assets/images/sousmenu/icon_onenote_noir.png";
import onenoteBlanc from "../../assets/images/sousmenu/icon_onenote_blanc.png";
import sharepointNoir from "../../assets/images/sousmenu/icon_sharepoint_noir.png";
import sharepointBlanc from "../../assets/images/sousmenu/icon_sharepoint_blanc.png";
import powerbiNoir from "../../assets/images/sousmenu/icon_powerbi_noir.png";
import powerbiBlanc from "../../assets/images/sousmenu/icon_powerbi_blanc.png";
import pointNoir from "../../assets/images/sousmenu/icon_point_noir.png";
import pointBlanc from "../../assets/images/sousmenu/icon_point_blanc.png";
import silaeNoir from "../../assets/images/sousmenu/icon_silae_noir.png";
import silaeBlanc from "../../assets/images/sousmenu/icon_silae_blanc.png";
import flipboardNoir from "../../assets/images/sousmenu/icon_flipboard_noir.png";
import flipboardBlanc from "../../assets/images/sousmenu/icon_flipboard_blanc.png";
import mediaNoir from "../../assets/images/sousmenu/icon_media_noir.png";
import mediaBlanc from "../../assets/images/sousmenu/icon_media_blanc.png";
import pdfNoir from "../../assets/images/sousmenu/icon_pdf_noir.png";
import pdfBlanc from "../../assets/images/sousmenu/icon_pdf_blanc.png";
import missionNoir from "../../assets/images/sousmenu/icon_missions_noir.png";
import missionBlanc from "../../assets/images/sousmenu/icon_missions_blanc.png";

const ComponentSousmenu = (props) => {
  const { nom, url, cible, icone, isCalendarView, idMenu } = props;

  const switchIcon = () => {
    switch (icone) {
      case "generique":
        if (isCalendarView) return generiqueNoir;
        else return generiqueBlanc;

      case "pointjaune":
        if (isCalendarView) return pointNoir;
        else return pointBlanc;

      case "silae":
        if (isCalendarView) return silaeNoir;
        else return silaeBlanc;

      case "onenote":
        if (isCalendarView) return onenoteNoir;
        else return onenoteBlanc;

      case "sharepoint":
        if (isCalendarView) return sharepointNoir;
        else return sharepointBlanc;

      case "powerbi":
        if (isCalendarView) return powerbiNoir;
        else return powerbiBlanc;

      case "flipboard":
        if (isCalendarView) return flipboardNoir;
        else return flipboardBlanc;

      case "media":
        if (isCalendarView) return mediaNoir;
        else return mediaBlanc;

      case "pdf":
        if (isCalendarView) return pdfNoir;
        else return pdfBlanc;

      case "mission":
        if (isCalendarView) return missionNoir;
        else return missionBlanc;

      default:
        return "";
    }
  };

  return (
    <>
      {cible === "self" && (
        <Link
          id={"sousMenu_" + idMenu}
          className="sousMenuButton   pt-1 pb-1 text-center flex-grow-1"
          to={url}
        >
          <Image src={switchIcon()} className="ms-2 me-2" /> {nom}
        </Link>
      )}
      {!cible && (
        <>
          <a
            id={"sousMenu_" + idMenu}
            className="sousMenuButton  pt-1 pb-1 text-center flex-grow-1"
            href={url}
            target="_blank"
            rel="noreferrer"
          >
            <Image src={switchIcon()} className="ms-2 me-2" /> {nom}
          </a>
        </>
      )}
    </>
  );
};

export default ComponentSousmenu;
